import { NavyAtmosphere, ScrollReveal, SplitReveal, TextStagger } from '@/components/motion';
import { EnquiryForm } from '@/components/sections';

/**
 * ApplyPage (/apply) — the destination for the site-wide "Apply now" / "Start
 * your application" CTAs. A compact navy hero introduces the step, then the
 * shared enquiry form (the application entry point) sits immediately below so
 * the visitor lands straight on it and closes the page.
 *
 * A real page (rather than a redirect to an in-page anchor) keeps the CTA
 * reliable and the form visible without depending on deep-hash scrolling.
 */
export function ApplyPage() {
  return (
    <div className="bg-background">
      {/* ── HERO ─────────────────────────────────────────────────────────── */}
      <section className="relative isolate overflow-hidden bg-brand-navy py-24 md:py-28">
        <NavyAtmosphere />
        <div className="relative z-10 mx-auto w-full max-w-3xl px-6 text-center">
          <TextStagger
            text="Apply"
            className="font-label text-xs tracking-[0.24em] text-brand-gold-light uppercase"
          />
          <SplitReveal
            as="h1"
            by="lines"
            className="mt-4 font-display text-4xl leading-[1.05] text-white md:text-6xl"
          >
            Start your application.
          </SplitReveal>
          <ScrollReveal from="up" delay={0.1}>
            <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70">
              Tell us a little about yourself and the route you have in mind. An IBAS admissions
              adviser will be in touch to guide you through the next steps — study your way, and
              begin when you are ready.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* The shared enquiry form is the application entry point. */}
      <EnquiryForm />
    </div>
  );
}
